export class BuyingLink {
  shop: string;
  link: string;
  text: string;

  constructor(
    shop: string,
    link: string,
    text: string
  ) {
    this.shop = shop;
    this.link = link;
    this.text = text;
  }
}

export class BookPrice {
  actualPrice: string;
  discountedPrice: string;
  currency: string;

  constructor(
    actualPrice: string,
    discountedPrice: string,
    currency: string
  ) {
    this.actualPrice = actualPrice;
    this.discountedPrice = discountedPrice;
    this.currency = currency;
  }
}

export class TicketPrice {
  actualPrice: string;
  discountedPrice: string;
  currency: string;

  constructor(
    actualPrice: string,
    discountedPrice: string,
    currency: string
  ) {
    this.actualPrice = actualPrice;
    this.discountedPrice = discountedPrice;
    this.currency = currency;
  }
}

export class BookAddModel {
  title: string;
  description: string;
  noOfPages: string;
  price: BookPrice[];
  buyingLink: BuyingLink[];
  imageUrls: string[];

  constructor(
    title: string,
    description: string,
    noOfPages: string,
    price: BookPrice[],
    buyingLink: BuyingLink[],
    imageUrls: string[]
  ) {
    this.title = title;
    this.description = description;
    this.noOfPages = noOfPages;
    this.price = price;
    this.buyingLink = buyingLink;
    this.imageUrls = imageUrls;
  }
}

export class EventAddModel {
  title: string;
  description: string;
  location: string;
  startDate: string;
  endDate: string;
  ticketType: string;
  ticketPrice: TicketPrice[];
  registerLink: string;
  imageUrls: string[];

  constructor(
    title: string,
    description: string,
    location: string,
    startDate: string,
    endDate: string,
    ticketType: string,
    ticketPrice: TicketPrice[],
    registerLink: string,
    imageUrls: string[]
  ) {
    this.title = title;
    this.description = description;
    this.location = location;
    this.startDate = startDate;
    this.endDate = endDate;
    this.ticketType = ticketType;
    this.ticketPrice = ticketPrice;
    this.registerLink = registerLink
    this.imageUrls = imageUrls
  };
}

export class BlogPostAddModel {
  title: string;
  description: string;
  postedDate: string;
  postedBy: string;
  post: string;
  imageUrls: string[];

  constructor(
    title: string,
    description: string,
    postedDate: string,
    postedBy: string,
    post: string,
    imageUrls: string[]

  ) {
    this.title = title;
    this.description = description;
    this.postedDate = postedDate;
    this.postedBy = postedBy;
    this.post = post;
    this.imageUrls = imageUrls
  };
}

export class EventGetModel {
  _id: string;
  title: string;
  description: string;
  location: string;
  startDate: string;
  endDate: string;
  ticketType: string;
  ticketPrice: TicketPrice[];
  registerLink: string;
  imageUrls: string[];
  startDateToShow?: string;
  endDateToShow?: string;

  constructor(
    _id: string,
    title: string,
    description: string,
    location: string,
    startDate: string,
    endDate: string,
    ticketType: string,
    ticketPrice: TicketPrice[],
    registerLink: string,
    imageUrls: string[],
    startDateToShow?: string,
    endDateToShow?: string
  ) {
    this._id = _id;
    this.title = title;
    this.description = description;
    this.location = location;
    this.startDate = startDate;
    this.endDate = endDate;
    this.ticketType = ticketType;
    this.ticketPrice = ticketPrice;
    this.registerLink = registerLink,
      this.imageUrls = imageUrls,
      this.startDateToShow = startDateToShow,
      this.endDateToShow = endDateToShow
  };
}

export class BlogPostGetModel {
  _id: string;
  title: string;
  description: string;
  postedDate: string;
  postedBy: string;
  post: string;
  imageUrls: string[];
  postedDateToShow?: string;

  constructor(
    _id: string,
    title: string,
    description: string,
    postedDate: string,
    postedBy: string,
    post: string,
    imageUrls: string[],
    postedDateToShow?: string

  ) {
    this._id = _id;
    this.title = title;
    this.description = description;
    this.postedDate = postedDate;
    this.postedBy = postedBy;
    this.post = post;
    this.imageUrls = imageUrls,
    this.postedDateToShow = postedDateToShow
  };
}

export class BookGetModel {
  _id: string;
  title: string;
  description: string;
  noOfPages: string;
  price: BookPrice[];
  buyingLink: BuyingLink[];
  imageUrls: string[];

  constructor(
    _id: string,
    title: string,
    description: string,
    noOfPages: string,
    price: BookPrice[],
    buyingLink: BuyingLink[],
    imageUrls: string[]
  ) {
    this._id = _id;
    this.title = title;
    this.description = description;
    this.noOfPages = noOfPages;
    this.price = price;
    this.buyingLink = buyingLink;
    this.imageUrls = imageUrls;
  }
}

export class SlokaTypeModel {
  id: string;
  title: string;
  description: string;
  totalSlokas: number;
  imageUrl: string;

  constructor(
    id: string,
    title: string,
    description: string,
    totalSlokas: number,
    imageUrl: string
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.totalSlokas = totalSlokas;
    this.imageUrl = imageUrl;
  }
}

export class RegisteredUserModel {
  displayName: string;
  email: string;
  provider: [string];
  _id: string;

  constructor(
    displayName: string,
    email: string,
    provider: [string],
    _id: string,
  ) {
    this.displayName = displayName;
    this.email = email;
    this.provider = provider;
    this._id = _id;
  }
}

export interface SlokaTypeBackendModel {
  title: string;
  description: string;
  imageUrl: string;
  _id: string;
}

export interface SlokaBackendModel {
  videoLink: string;
  audioLink: string;
  pdfLink: string;
  synopsis: string;
  english: string;
  sanskrit: string;
  both: string;
  slokaTypeId: string;
  title: string;
  _id: string;
}

export interface AddSlokaTypeBackendModel {
  description: string;
  imageUrl: string;
  title: string;
  _id: string;
}

export class AddSlokaTypeModel {
  title: string;
  description: string;
  imageUrl: string;

  constructor(title: string, description: string, imageUrl: string) {
    this.title = title;
    this.description = description;
    this.imageUrl = imageUrl;
  }
}

export class AddOfferModel {
  title: string;
  description: string;
  imageUrl: string;

  constructor(title: string, description: string, imageUrl: string) {
    this.title = title;
    this.description = description;
    this.imageUrl = imageUrl;
  }
}

export class UpdateSlokaTypeModel {
  title: string;
  description: string;
  imageUrl: string;
  _id: string;

  constructor(
    title: string,
    description: string,
    imageUrl: string,
    _id: string
  ) {
    this.title = title;
    this.description = description;
    this.imageUrl = imageUrl;
    this._id = _id;
  }
}

export class AddSlokaModel {
  title: string;
  slokatypeId: string;
  synopsis: string;
  english: string;
  sanskrit: string;
  both: string;
  videoLink: string;
  audioLink: string;
  pdfLink: string;

  constructor(
    title: string,
    slokatypeId: string,
    synopsis: string,
    english: string,
    sanskrit: string,
    both: string,
    videoLink: string,
    audioLink: string,
    pdfLink: string
  ) {
    this.title = title;
    this.slokatypeId = slokatypeId;
    this.synopsis = synopsis;
    this.english = english;
    this.sanskrit = sanskrit;
    this.both = both;
    this.videoLink = videoLink;
    this.audioLink = audioLink;
    this.pdfLink = pdfLink;
  }
}

export class UpdateSlokaModel {
  title: string;
  slokatypeId: string;
  synopsis: string;
  english: string;
  sanskrit: string;
  both: string;
  videoLink: string;
  audioLink: string;
  pdfLink: string;
  _id: string;

  constructor(
    title: string,
    slokatypeId: string,
    synopsis: string,
    english: string,
    sanskrit: string,
    both: string,
    videoLink: string,
    audioLink: string,
    pdfLink: string,
    _id: string
  ) {
    this.title = title;
    this.slokatypeId = slokatypeId;
    this.synopsis = synopsis;
    this.english = english;
    this.sanskrit = sanskrit;
    this.both = both;
    this.videoLink = videoLink;
    this.audioLink = audioLink;
    this.pdfLink = pdfLink;
    this._id = _id;
  }
}

export interface PopupAction {
  isPopup: boolean;
  message: string;
  isOk: boolean;
  isDelete: boolean;
  response: string;
}
